export const cardTheme = {
  shadow: '{sd.shadow.box}',
  extend: {
    colorScheme: {
      shadow: '0px 3px 6px 0px #33333329'
    }
  }
};
